// The Financial Statements picker: one searchable list holding Consolidated,
// each Sage entity, and under each entity the deals that roll up to it, then
// the deals no entity owns. Pure, so the grouping and the search are testable.
//
// A deal under two entities appears under both; its value carries the entity
// code so the two rows stay distinct, and either one selects the same deal.

export const CONSOLIDATED = 'consolidated';

export function scopeItems(options) {
  const items = [{ value: CONSOLIDATED, label: 'Consolidated — all entities', group: CONSOLIDATED }];
  for (const e of options?.entities || []) {
    const group = `entity:${e.code}`;
    items.push({ value: group, label: `${e.name} (${e.code})`, subtitle: 'Entity', group });
    for (const d of e.deals || []) {
      items.push({ value: `deal:${e.code}:${d.id}`, label: d.name, indent: 1, group });
    }
  }
  for (const d of options?.unassignedDeals || []) {
    items.push({ value: `deal::${d.id}`, label: d.name, subtitle: 'Deal — rolls up to no Sage entity', group: `deal::${d.id}` });
  }
  return items;
}

const words = (q) => String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
const hit = (item, ws) => {
  const text = `${item.label} ${item.subtitle || ''}`.toLowerCase();
  return ws.every(w => text.includes(w));
};

// An entity row matching keeps all its deals; a deal matching keeps its entity
// row, so a hit is never shown without the place it sits.
export function scopeMatcher(items) {
  return (item, query) => {
    const ws = words(query);
    if (!ws.length) return true;
    if (hit(item, ws)) return true;
    const siblings = items.filter(i => i.group === item.group && i !== item);
    if (item.indent) return siblings.some(i => !i.indent && hit(i, ws));
    return siblings.some(i => hit(i, ws));
  };
}

export function scopeFromValue(value) {
  const v = String(value || '');
  if (v === CONSOLIDATED) return { scope: 'consolidated' };
  if (v.startsWith('entity:')) return { scope: 'entity', entity: v.slice('entity:'.length) };
  if (v.startsWith('deal:')) return { scope: 'deal', dealId: v.slice(v.lastIndexOf(':') + 1) };
  return { scope: null };
}
